import React, { Component } from 'react';
import {Accordion,AccordionTab} from 'primereact/accordion';
import QualitativeMatrix from './QualitativeMatrix';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import {
    encodeTabs
} from '../utils/qualitativeMatrixGroupUtils';


class QualitativeMatrixGroup extends Component {

    constructor(props) {
        super(props);
        this.group = props.group;
        this.state = {
            activeIndex: 0,
            qualitativetabs: encodeTabs(JSON.parse(this.props.qualitativematrix)),
        }
    }
    
    render() {

        let dynamicTabsPanel= this.state.qualitativetabs.map((col, i) => {
                return <AccordionTab key={i} header={col.name}>
                <QualitativeMatrix matrix={col.field} name={col.name} matrixId={col.field.id}/>
            </AccordionTab>
        });

        return (
            <div>
                <Accordion activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
                {dynamicTabsPanel}
                </Accordion>
            </div>
        );
    }
}

export default QualitativeMatrixGroup;
